import i18nFactory from '@yandex-int/i18n';
import { RadioButton } from 'lego-on-react';
import * as React from 'react';
import { ChangeEvent } from 'react';

import * as keyset from './BulkReplacementModeChooser.i18n';

const i18n = i18nFactory(keyset);

export enum BulkReplacementRadio {
    REPLACE = 'replace-radio',
    DELETE = 'delete-radio'
}

export interface BulkReplacementModeChooserProps {
    value: BulkReplacementRadio;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    replaceTitle: string;
}

export class BulkReplacementModeChooser extends React.Component<
    BulkReplacementModeChooserProps
> {
    render(): React.ReactNode {
        const { value, onChange, replaceTitle } = this.props;

        return (
            <RadioButton
                size="n"
                theme="normal"
                view="default"
                freeWidth={true}
                value={value}
                onChange={onChange}
            >
                <RadioButton.Radio
                    key={BulkReplacementRadio.REPLACE}
                    value={BulkReplacementRadio.REPLACE}
                >
                    {replaceTitle}
                </RadioButton.Radio>
                <RadioButton.Radio
                    key={BulkReplacementRadio.DELETE}
                    value={BulkReplacementRadio.DELETE}
                >
                    {i18n('delete')}
                </RadioButton.Radio>
            </RadioButton>
        );
    }
}
